import React, { Fragment } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import NotFound from "./components/NotFound";
import PrivateRouter from "./components/System/PrivateRouter";
import PublicRouter from "./components/System/PublicRouter";
import GuestRouter from "./components/System/GuestRouter";
import { LoginModal } from 'core/context';

import { useNavigateStack } from "core/hooks/useCustomNavigate";


let routers = [
  {
    name: "NOT_FOUND",
    path: "*",
    element: <NotFound />,
  },
];

let routerName = {};

const RouteStack = ({children}: {children: React.ReactNode}) => {
  useNavigateStack();
  return <Fragment>{children}</Fragment>
}

const getAllModules = () => {
  const routerModules = require.context('./../modules/', true, /router.tsx$/);
  const modules = require.context('./../modules/', true, /module.ts$/);
	return {routerModules, modules}
}

const dynamicModules = getAllModules();

dynamicModules.modules.keys().forEach((mpath: any) => {
  const moduleJson = dynamicModules.modules(mpath).default;
  
  if (moduleJson?.status?.router) {
    const key = mpath.toString().replace("module.ts", "router.tsx");
    const router = dynamicModules.routerModules(key);
    const rs = router.default || router;
    rs.forEach((r: any) => {
      routerName = { ...routerName, [r.name]: r.path };
      
      const el = !Object.hasOwn(r, 'auth') ? (
        <GuestRouter>{r.element}</GuestRouter>
      ) : (
        r.auth ? (
          <PrivateRouter>{r.element}</PrivateRouter>
        ) : (
          <PublicRouter>{r.element}</PublicRouter>
        )
      );
      routers = [
        ...routers,
        {
          name: r.name,
          element: <RouteStack>{el}</RouteStack>,
          path: `${r.path}`,
          auth: r.auth,
          title: r.title,
        } as any,
      ];
    });
  }
});


export const RouterName: any = routerName;

export const Router = routers;

export const AppRouter = createBrowserRouter(
  [
    {
      path: `/`,
      element: <Fragment>
        <Outlet />
        <LoginModal />
      </Fragment>, // Use a Layout component to render children
      children: Router,
    },
  ],
  { basename: ``}
);

export function route(routeName: any, ...rest: any) {
  if (!routeName) {
    return '';
  }
  rest.map((value: any) => {
    routeName = routeName.replace(/:[a-z]*/, value);
  });

  return routeName;
}
